import React, { useState } from 'react';
import Container from '../../../components/UI/Container';
import Box from '../../../components/Box';
import GlideCarousel from '../../../components/GlideCarousel';
import GlideSlide from '../../../components/GlideCarousel/glideSlide';
import { enFr, getLang } from '../../../utils';
import { fixImagePaths } from '../../../utils/image-helpers';
import PastWorkWrapper from './pastWork.style';

import awakenData from '../../../assets/data/awaken/index.json';
import awakenFrenchData from '../../../assets/data/awaken-french/index.json';

const PastWork = () => {
  const lang = getLang();
  const localizedData = fixImagePaths(lang === 'fr' ? awakenFrenchData : awakenData);
  const clients = localizedData.CLIENTS;
  const caseStudies = clients.filter((c) => c.caseStudy);
  const [activeCS, setActiveCS] = useState(0);

  const carouselOptions = {
    type: 'carousel',
    autoplay: 6000,
    animationDuration: 800,
    perView: 2,
    gap: 30,
    bound: true,
    breakpoints: {
      1199: { perView: 2, peek: { before: 80, after: 80 } },
      990: { perView: 1, peek: { before: 120, after: 120 } },
      767: { perView: 1, peek: { before: 60, after: 60 } },
      575: { perView: 1, gap: 15, peek: { before: 15, after: 15 } },
    },
  };

  return (
    <PastWorkWrapper id="past-work">
      <Container>
        <div className="section-header">
          <h2>{enFr('Client Work & Testimonials', 'Projets clients & témoignages')}</h2>
          <p className="section-subtitle">
            {enFr(
              'Over 20 years of building production-grade web applications, custom platforms, and integrated systems for clients across industries. Here is a selection of our work and what our clients have to say.',
              'Plus de 20 ans de développement d\u2019applications web de calibre production, de plateformes sur mesure et de systèmes intégrés pour des clients de divers secteurs. Voici une sélection de nos réalisations et ce que nos clients en disent.'
            )}
          </p>
        </div>

        <div className="client-logos">
          {clients.map((client, index) => (
            client.logoGrey && (
              <div className="logo-item" key={index}>
                <img src={client.logoGrey} alt={client.company} />
              </div>
            )
          ))}
        </div>

        <div className="past-case-studies">
          <h3 className="subsection-title">{enFr('Selected Web Projects', 'Projets web sélectionnés')}</h3>
          <div className="cs-tabs">
            {caseStudies.map((cs, index) => (
              <button
                key={index}
                className={`cs-tab ${activeCS === index ? 'active' : ''}`}
                onClick={() => setActiveCS(index)}
                type="button"
              >
                {cs.company}
              </button>
            ))}
          </div>
          {caseStudies.map((cs, index) => (
            activeCS === index && (
              <div className="cs-detail" key={index}>
                <div className="cs-detail-header">
                  <span className="cs-headline">{cs.headline}</span>
                  <div className="cs-meta">
                    <span className="cs-company">{cs.company}</span>
                    <span className="cs-city">{cs.city}</span>
                  </div>
                </div>
                <div className="cs-detail-body">
                  <div className="cs-info">
                    <p>{cs.description}</p>
                    <div className="cs-specs">
                      {cs.development && (
                        <div className="spec-group">
                          <span className="spec-label">{enFr('Development', 'Développement')}</span>
                          {cs.development.map((d, i) => (
                            <span className="spec-item" key={i}>{d.content}</span>
                          ))}
                        </div>
                      )}
                      {cs.technology && (
                        <div className="spec-group">
                          <span className="spec-label">{enFr('Technology', 'Technologie')}</span>
                          {cs.technology.map((t, i) => (
                            <span className="spec-item" key={i}>{t.content}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {cs.review && (
                    <div className="cs-testimonial">
                      <blockquote>{cs.review}</blockquote>
                      <div className="testimonial-author">
                        <strong>{cs.name}</strong>
                        {cs.designation && <span>{cs.designation}</span>}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          ))}
        </div>

        <div className="testimonials-section">
          <h3 className="subsection-title">{enFr('What Our Clients Say', 'Ce que disent nos clients')}</h3>
          <div className="testimonials-carousel">
            <GlideCarousel
              options={carouselOptions}
              carouselSelector="past_work__slider"
              controls={false}
              bullets={true}
              numberOfBullets={clients.length}
            >
              <>
                {clients.map((client, index) => (
                  <GlideSlide key={`pw-testimonial-${index}`}>
                    <div className="testimonial-card">
                      <p className="testimonial-text">{client.review}</p>
                      <div className="testimonial-footer">
                        <strong>{client.name}</strong>
                        {client.designation && <span>{client.designation}</span>}
                        {client.logoGrey && (
                          <img src={client.logoGrey} alt={client.company} className="testimonial-logo" />
                        )}
                      </div>
                    </div>
                  </GlideSlide>
                ))}
              </>
            </GlideCarousel>
          </div>
        </div>
      </Container>
    </PastWorkWrapper>
  );
};

export default PastWork;
